var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-wrap text-center"},[_c('audio',{attrs:{"src":_vm.pathView,"autoplay":_vm.autoPlay,"controls":"","controlsList":"nodownload"}})])}
var staticRenderFns = []

export { render, staticRenderFns }